<template>
  <div class="LayoutHeader" ref="LayoutHeader">
    <div class="LayoutHeader-cont">
      <div class="header-left">
        <span>欢迎来到千里马招标网</span>
        <div class="substation">
          <div class="substation-text">各省分站</div>
          <div class="substation-box">
            <div class="currentRegion">当前地区：{{ currentRegion }}</div>
            <ul class="fenquwrap">
              <li v-for="item in provinceList" :key="item.id">
                <span class="fenqu">{{ item.name }}</span>
                <a
                  v-for="ite in item.children"
                  :key="ite.id"
                  v-track
                  :data-oid="2136"
                  :data-extendinfo="ite.name"
                  target="_blank"
                  :href="ite.url ? ite.url : `/zb/area_${ite.id}/`"
                  :title="ite.name+'招标网'"
                  >{{ ite.name }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="header-right">
        <p
          v-if="isShowCustomUserCenter"
          class="custom-user-center"
          v-track
          :data-oid="2136"
          :data-extendinfo="'定制版会员中心'"
          @click="toCustomUserCenter"
        >
          定制版会员中心
        </p>
        <p>
          <a :href="ABOUT_US" target="_blank" v-track :data-oid="2136" :data-extendinfo="'关于千里马'">关于千里马</a>
        </p>

        <p>
          <ProductsServicesButtonModule />
        </p>
        <p>
          <span
            class="enterprise-package"
            v-track
            :data-oid="2136"
            :data-extendinfo="'企业套餐'"
            @click="goToUrl(ENTERPRISE_PACKAGE)"
          >
            企业套餐
          </span>
        </p>
        <template v-if="!isLogin">
          <el-button
            class="login-but"
            size="small"
            v-track
            :data-oid="2136"
            :data-extendinfo="'登录'"
            @click="showLoginDialog"
          >
            登录
          </el-button>
          <el-button
            class="reg-but"
            size="small"
            v-track
            :data-oid="2136"
            :data-extendinfo="'免费注册'"
            type="primary"
            @click="registerUrl"
          >
            免费注册
          </el-button>
        </template>
        <template v-if="isLogin">
          <div class="avatar">
            <el-avatar
              :src="require(`../../assets/img/default_avatar${userInfo.sex === 'f' ? '_f' : ''}.png`)"
            ></el-avatar>
            <div class="avatar-box">
              <div class="user_info">
                <div class="left">
                  <img
                    class="avatar"
                    :src="require(`../../assets/img/default_avatar${userInfo.sex === 'f' ? '_f' : ''}.png`)"
                    alt="default_avatar"
                    width="46"
                    height="46"
                  />
                </div>
                <div class="right">
                  <div class="right_top">
                    <div class="nickname" :title="userInfo.linkName">
                      {{ userInfo.linkName || "未命名" }}
                    </div>
                  </div>
                  <div class="right_bottom">
                    <div class="companyName" :title="userInfo.companyName">
                      {{ userInfo.companyName || "未填写公司名称" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="member">
                <div class="left">
                  <div class="left_top">{{ userInfo.memberLevelName }}</div>
                  <div class="left_bottom">
                    <span class="area" :title="userInfo.areaName">{{ userInfo.areaName }}</span>
                  </div>
                </div>
                <div class="right" @click="handleUpgradeClick">
                  <img v-if="userInfo.memberLevel <= 5" src="../../assets/img/header/btn_upgrade.png" alt="btn" />
                  <img v-else src="../../assets/img/header/btn_upgrade&renew.png" alt="btn" />
                </div>
              </div>
              <div class="cell no-hover">
                <span>{{ userInfo.username }}</span
                ><span class="tip">用户名</span>
              </div>
              <div class="cell" @click="handleUserInfoClick">
                <span>账号信息</span>
              </div>
              <div class="cell" @click="handleCenter">
                <span>会员中心</span>
              </div>
              <div class="logout">
                <div class="cell" @click="handleLoginOut">
                  <span>退出登录</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ABOUT_US,
  CUSTOM_USER_CENTER_URL,
  ENTERPRISE_PACKAGE,
  OLD_HOME_ZHAOBIAO,
  OLD_USER_CENTER_URL,
  PUBLIC_PATH,
  ACCOUNT_INFORMATION,
  CHOOSE_PACKAGE,
} from "../../utils/constants/constants";
import ProductsServicesButtonModule from "./ProductServicesButtonModule";
import { clearCookies, getLoginStatus } from "../../utils/common";
import {
  commonCusApiHomepageIdTypeGw,
  restUserApiHomepageLogout,
  restUCompanyGetCompanyInfo,
  restPayPayDialogInfoNeedBuyMoreDialog,
} from "../../services/home";
import { OID_MAP } from "../../utils/constants/constants.track";
import { areaProvinceJSON } from "../../assets/areaProvinceJSON";
import { CookieKeys, Cookies } from "../../utils/cookieKey";

export default {
  name: "LibLayoutHeaderOld",
  components: { ProductsServicesButtonModule },
  props: {
    currentRegion: {
      type: String,
      default: "全国",
    },
  },
  data() {
    return {
      OID_MAP,
      ENTERPRISE_PACKAGE,
      ABOUT_US,
      OLD_HOME_ZHAOBIAO,
      toFixed: false,
      isEjected: "",
      scrollTop: 0,
      isShowCustomUserCenter: false,
      provinceList: [],
      userInfo: {},
    };
  },
  computed: {
    isLogin() {
      return getLoginStatus();
    },
  },
  watch: {},
  methods: {
    showLoginDialog() {
      window.open(OLD_USER_CENTER_URL + "/login");
    },
    registerUrl() {
      window.open(OLD_USER_CENTER_URL + "/register" + "?referUrl=" + encodeURIComponent(window.location.href));
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    closeDialog() {},
    handleCenter() {
      window.open(OLD_USER_CENTER_URL);
    },
    handleLogo() {
      window.location.href = PUBLIC_PATH;
    },
    handleLoginOut() {
      this.$confirm("您确定要退出登录？", "提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        lockScroll: false,
      })
        .then(async () => {
          try {
            await restUserApiHomepageLogout();
            this.$message({
              message: "您已退出",
              type: "info",
              onClose: () => {
                this.redirectToLoginPage();
              },
            });
          } catch (e) {
            this.$message({
              message: "退出失败，稍后重试",
              type: "error",
              onClose: () => {},
            });
          }
        })
        .catch(() => {});
    },
    // 跳转至登录页
    redirectToLoginPage() {
      // 清除cookies
      clearCookies();
      window.location.replace(PUBLIC_PATH);
    },
    goToUrl(path) {
      window.open(path);
    },

    async init() {
      if (getLoginStatus()) {
        const userInfo = await restUCompanyGetCompanyInfo().then((res) => res.data);
        Cookies.set(CookieKeys.userInfo, JSON.stringify(userInfo), { domain: ".qianlima.com" });
        this.userInfo = userInfo;
        const res = await commonCusApiHomepageIdTypeGw({ id: this.userInfo.userId });
        // type > 0 展示 --- 李雷鹏
        this.isShowCustomUserCenter = res.data.type > 0;
      }
    },
    toCustomUserCenter() {
      window.location.href = CUSTOM_USER_CENTER_URL;
    },
    handleUserInfoClick() {
      window.location.href = ACCOUNT_INFORMATION;
    },
    handleUpgradeClick() {
      if (this.userInfo.memberLevel <= 5) {
        restPayPayDialogInfoNeedBuyMoreDialog({ type: 15 }).then((res) => {
          if (res.code !== 200) {
            return;
          }
          if (res.data.needDialog === true) {
            //sourceType: 1, //来源类型 1:'新企业套餐页',2:'2.0会员中心首页',3:'2.0顶部个人信息顶部弹框',4:'2.0会员套餐页' selectedPackage：1 普通会员  2 高级会员  3VIP
            window.open(CHOOSE_PACKAGE + "?sourceType=3");
          } else {
            this.$message.warning(`请联系您的专属客服进行开通～`);
          }
        });
      } else {
        this.$message.warning(`请联系您的专属客服进行开通～`);
      }
      this.$emit("cell", "upgrade");
    },
  },
  created() {
    this.provinceList = areaProvinceJSON.slice(0, areaProvinceJSON.length - 1);

    this.init();
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.LayoutHeader {
  width: 100%;
  min-width: 1000px;
  height: 48px;
  background: #f2f2f4;
  margin: 0 auto;
  color: #2a2b33;
  font-size: 14px;
  p,
  ul,
  li {
    margin: 0;
    padding: 0;
  }
  a {
    text-decoration: none;
    color: #2a2b33;
  }
  .LayoutHeader-cont {
    max-width: 1165px;
    min-width: 1000px;
    // padding: 0 70px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .header-left {
    display: flex;
    align-items: center;

    .logo {
      cursor: pointer;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    & > p {
      margin-right: 26px;

      a {
        &:hover {
          color: #d06957;
          font-weight: bold;
        }
      }
    }
    .custom-user-center {
      margin-left: 26px;
      cursor: pointer;
      color: #d06957;
    }

    .enterprise-package {
      padding-left: 24px;
      color: #be851d;
      background: url("../../assets/img/header/enterprise-package.png") no-repeat;
      background-size: 22px 22px;
      cursor: pointer;

      &:hover {
        color: #eba31f;
        font-weight: bold;
      }
    }

    .el-button {
      width: 80px;
      font-weight: 550;
      border-radius: 4px;
      font-size: 14px;
      padding: 7px 0px;
      &:hover {
        background: #f66d59;
        border-color: #f66d59;
      }
    }

    .login-but {
      background: rgba(0, 0, 0, 0);
      border-color: #d06957;
      color: #d06957;

      &:hover {
        background: rgba(0, 0, 0, 0);
        border-color: #f66d59;
        color: #f66d59;
      }
    }
    .reg-but {
      background: #f66d59;
      border-color: #f66d59;
      width: 80px;
    }
    .userInfo {
      background: url("../../assets/img/header/avator.png") no-repeat;
      background-size: 22px 22px;
      background-position-x: left;
      background-position-y: center;
      padding-left: 24px;
    }

    .loginOut {
      cursor: pointer;

      &:hover {
        color: #f66d59;
      }
    }
  }

  .avatar {
    position: relative;
    height: 48px;
    display: flex;
    align-items: center;
    .el-avatar {
      width: 31px;
      height: 31px;
      cursor: pointer;
    }
    &:hover {
      .avatar-box {
        display: block;
      }
    }
    .avatar-box {
      position: absolute;
      top: 48px;
      right: 0;
      width: 300px;
      background: #fff;
      z-index: 22;
      display: none;
      border-radius: 4px;
      box-shadow: 0px 4px 10px 0px rgba(8, 21, 78, 0.07);
    }
    .user_info {
      // width: 100%;
      height: 90px;
      background: url("../../assets/img/bg-popup-user.png") center center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 20px;
      color: white;
      border-radius: 4px 4px 0 0;

      .left {
        display: flex;

        .avatar {
        }
      }

      .right {
        margin-left: 8px;

        .right_top {
          display: flex;
          align-items: center;

          .nickname {
            max-width: 108px;

            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 600;
            color: #ffffff;
            line-height: 25px;

            //单行
            word-break: break-all;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .label {
            width: 82px;
            height: fit-content;
            background-color: #ffcec6;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 9px;

            font-size: 12px;
            font-family: NotoSansCJKsc, NotoSansCJKsc-Regular;
            font-weight: 400;
            color: #bc8600;
            line-height: 18px;
            letter-spacing: -0.61px;

            margin-left: 6px;
            cursor: pointer;

            img {
              width: 13px;
              height: 13px;
              margin-right: 1px;
              margin-left: -2px;
            }
          }
        }

        .right_bottom {
          margin-top: 9px;

          .companyName {
            max-width: 210px;

            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #ffffff;
            line-height: 17px;

            //单行
            word-break: break-all;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
        }
      }
    }

    .member {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px 6px 18px 20px;
      border-bottom: 1px #e8e8e8 solid;
      margin-bottom: 8px;

      .left {
        .left_top {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #333333;
          line-height: 22px;
        }

        .left_bottom {
          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
          margin-top: 8px;
          display: flex;

          .area {
            //单行
            word-break: break-all;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .expire_date {
            flex-shrink: 0;
          }
        }
      }

      .right {
        display: flex;
        cursor: pointer;

        img {
          width: 82px;
          object-fit: contain;
        }
      }
    }

    .cell {
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px 0 20px;

      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 20px;

      cursor: pointer;

      &:hover {
        background-color: rgba(223, 98, 80, 0.04);
      }

      .tip {
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }

    .no-hover {
      cursor: text;

      &:hover {
        background-color: white;
      }
    }

    .logout {
      margin-top: 8px;
      border-top: 1px #e8e8e8 solid;
      padding: 8px 0;
    }
  }
  .substation {
    position: relative;
    cursor: pointer;
    height: 48px;
    display: flex;
    align-items: center;
    .currentRegion {
      font-size: 16px;
      color: #2a2b33;
      line-height: 22px;
      padding: 16px;
      border-bottom: 1px solid #eeeef0;
    }
    &-text {
      width: 78px;
      height: 28px;
      font-size: 14px;
      text-align: center;
      color: #d06957;
      line-height: 26px;
      border: 1px solid #d06957;
      border-radius: 4px;
      margin-left: 26px;
      cursor: pointer;
    }
    &:hover {
      .substation-box {
        visibility: visible;
      }
    }
    &-box {
      position: absolute;
      visibility: hidden;
      margin: 0;
      padding: 0;
      z-index: 999;
      width: 438px;
      left: 26px;
      top: 48px;
      background: #ffffff;
      border: 1px solid #e5e6eb;
      border-radius: 4px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      .fenquwrap {
        padding: 8px 0 16px;
        li {
          display: flex;
          line-height: 20px;
          padding: 8px 0;
          .fenqu {
            display: block;
            width: 48px;
            height: 24px;
            background: rgba(248, 67, 67, 0.06);
            border-radius: 4px;
            text-align: center;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Medium;
            color: #df6250;
            line-height: 24px;
            margin-right: 2px;
            margin-left: 16px;
          }
          a {
            position: relative;
            display: block;
            line-height: 24px;
            float: left;
            margin: 0;
            padding: 0 12px;
            width: auto;
            text-align: left;
            background: #fff;
            color: #2a2b33;
            z-index: 999;
            &:hover {
              color: #df6250;
            }
          }
        }
      }
    }
  }
}
</style>
